import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean'
})
export class BooleanPipe implements PipeTransform {
  transform(value: unknown, yesValue: string, noValue: string, elseValue = ''): string {
    return value === true || value === 'true' ? yesValue
         : value === false || value === 'false' ? noValue
         : elseValue;
  }
}
